<template>
  <div class="admin-shops-edit">
    <div class="wrapper">
      <header-component></header-component>
      <admin-nav-menu></admin-nav-menu>
      <md-card id="shop-card">
        <md-card-content>
          <form>
          <md-input-container>
            <label>店名</label>
            <md-input v-model="shop.name"></md-input>
          </md-input-container>
          <md-input-container>
            <label>最寄駅</label>
            <md-input v-model="shop.station"></md-input>
          </md-input-container>
          <md-input-container>
            <label>場所（例：JR新宿駅から徒歩5分）</label>
            <md-input v-model="shop.place"></md-input>
          </md-input-container>
          <md-input-container>
            <label>食べログ・ぐるなびURL</label>
            <md-input v-model="shop.tabelog_or_gurunavi_url"></md-input>
          </md-input-container>
          <md-input-container>
            <label>都道府県（必ず県や都まで入れること）</label>
            <md-input v-model="shop.prefecture"></md-input>
          </md-input-container>
          <md-input-container>
            <label>住所</label>
            <md-input v-model="shop.address"></md-input>
          </md-input-container>
          <md-checkbox v-model="shop.closed">閉店</md-checkbox>
        </form>
        <md-button class="md-raised submit-button" v-on:click="onSubmit">登録</md-button>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import firebaseApp from '../../../firebaseApp'
import router from '../../../router'
import HeaderComponent from '../../Header.vue'
import AdminNavMenu from '../AdminNavMenu.vue'
import authenticateUser from '../../../auth'
import moment from 'moment'
const db = firebaseApp.firestore()

let data = {
  shop: {}
}

export default {
  name: 'admin-shops-edit',
  components: {
    HeaderComponent,
    AdminNavMenu
  },
  data () {
    return data
  },
  methods: {
    onSubmit: function () {
      const now = moment().toDate()
      db.doc(`shops/${this.$route.params.id}`).update({
        address: data.shop.address,
        closed: data.shop.closed,
        name: data.shop.name,
        place: data.shop.place,
        prefecture: data.shop.prefecture,
        station: data.shop.station,
        tabelog_or_gurunavi_url: data.shop.tabelog_or_gurunavi_url,
        updated_at: now
      })
      .then(function () {
        router.push({name: 'AdminShopsIndex'})
      })
      .catch(function (error) {
        alert(error + 'リクエストの削除に失敗しました。')
      })
    }
  },
  created () {
    authenticateUser().then(() => {
      db.doc(`shops/${this.$route.params.id}`).get().then(function (doc) {
        if (doc.exists) {
          data.shop = doc.data()
        } else {
          router.push({name: 'NotFound'})
        }
      })
    })
  },
  mounted () {
    this.$material.setCurrentTheme('admin')
  },
  destroyed () {
    this.$material.setCurrentTheme('default')
  }
}
</script>

<style scoped>

header {
  margin-left: -50px;
}

.wrapper {
  width: 960px;
  margin: 0 auto;
}

#shop-card {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
}

#shop-card table {
  border-spacing: 20px;
}

#shop-card th {
  font-size: 16px;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Shops/Edit.vue